<template>
    <div v-loading="loading">
        <el-table :data="compare" key="add" border style="width:97%">
            <el-table-column label="修改项" prop="name"></el-table-column>
            <el-table-column label="修改前" prop="before" ></el-table-column>
            <el-table-column label="修改后" prop="after" class-name="red-text"></el-table-column>
        </el-table>
    </div>
</template>
<style>
.red-text {
  color: red;
}
</style>
<script>
    import Time from '~/common/time';
    export default {
        name: "paikeNew",
        props:{
            edit_content:{
                required:true
            }
        },
        data(){
            return {
                loading: false,
                apps:[],
                compare:[],
                product_type: {
                    '1': '试用',
                    '2': '新增',
                    '3': '续费',
                },
            }
        },
        mounted(){
            this.compareApp();
        },
        methods:{
            compareApp(){
                const before_content = this.edit_content.before_content || {};
                const after_content = this.edit_content.content || {};
                if(Number(before_content.type) !== Number(after_content.type)){
                    this.addCompare('订单类型', this.product_type[before_content.type], this.product_type[after_content.type]);
                }
                if(Number(before_content.is_enable) !== Number(after_content.is_enable)){
                    this.addCompare('产品开关', Number(before_content.is_enable) ? '开启' : '关闭', Number(after_content.is_enable) ? '开启' : '关闭');
                }
                const before_start_at = this.formatDate(before_content.start_at);
                const before_end_at = this.formatDate(before_content.end_at);
                const after_start_at = this.formatDate(after_content.start_at);
                const after_end_at = this.formatDate(after_content.end_at);
                if(before_start_at !== after_start_at){
                    this.addCompare('开始时间', before_start_at, after_start_at);
                }
                if(before_end_at !== after_end_at){
                    this.addCompare('结束时间', before_end_at, after_end_at);
                }
                if(String(before_content.schoolId || '') !== String(after_content.schoolId || '')){
                    this.addCompare('排课ID', before_content.schoolId || '', after_content.schoolId || '');
                }
                if((before_content.schoolName || '') !== (after_content.schoolName || '')){
                    this.addCompare('排课车厢名称', before_content.schoolName || '', after_content.schoolName || '');
                }
                if((before_content.memo || '') !== (after_content.memo || '')){
                    this.addCompare('备注', before_content.memo || '', after_content.memo || '');
                }
            },

            formatDate(timestamp){
                return Number(timestamp) > 0 ? Time.asDateDay(Number(timestamp)) : '';
            },

            addCompare(name, before, after){
                this.compare.push({
                    name: name,
                    before: before,
                    after: after
                });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order/recoder/paikeNew.vue